import React, {Component} from "react";
import PanelGroupController from "../../components/PanelGroupController";
import {fromJS} from "immutable";
import PropertiesList from "../../components/panels/PropertiesList";
import Loading from "../../components/Loading";
import GraphQLErrors from "../../components/GraphQLErrors";
import {graphql} from "react-apollo";
import {GET_ACCOUNT_HOLDER} from "../../queries/customers";

class AccountHolderPropertiesPanel extends Component {

  render() {
    let elements = null;
    if (!this.props.accountId) {
      elements = <p className="u-no-selection">Nothing selected</p>
    } else {
      let {loading, error, accountHolder} = this.props.data;
      if (loading) return <Loading />
      if (error) return <GraphQLErrors error={error} />

      let properties = fromJS([
        {prop: "customerId", label: "Id", type: "customerId"},
        {prop: "name", label: "Name", type: "string"},
        {prop: "email", label: "Email", type: "string"},
        {prop: "phone", label: "Phone", type: "telephone"},
        {prop: "referralCode", label: "Ref. Code", type: "id"},
        {prop: "memberSince", label: "Member Since", type: "string"},
        {prop: "authInvited", label: "Auth Invite Sent", type: "boolean"},
        {prop: "authProvisioned", label: "Auth Provisioned", type: "boolean"},
        {prop: "status", label: "Status", type: "string"},
        {prop: "vip", label: "VIP", type: "boolean"},
        {prop: "---subs", label: "Subscriptions", type: "category"},
        {prop: "subsActive", label: "Active", type: "integer"},
        {prop: "subsPaused", label: "Paused", type: "integer"},
        {prop: "subsCancelled", label: "Cancelled", type: "integer"},
        {prop: "---policies", label: "Policies", type: "category"},
        {prop: "tacAccepted", label: "Accepted T&C", type: "boolean"},
        {prop: "tacVersion", label: "T&C Version", type: "string"},
        {prop: "marketingAccepted", label: "Marketing", type: "boolean"},
        {prop: "---promos", label: "Available Promotion", type: "category"},
        {prop: "referralOnboardingPromoType", label: "Type", type: "id"},
        {prop: "referralOnboardingPromoId", label: "Code", type: "id"}
      ])
      elements = <PropertiesList properties={properties} data={fromJS(accountHolder)} />
    }

    return (
      <PanelGroupController title="Customer" expanded={this.props.expanded}>
        {elements}
      </PanelGroupController>
    )
  }

}

const withQuery = graphql(GET_ACCOUNT_HOLDER, {
  skip: (props) => !props.accountId,
  options: (props) => ({
    fetchPolicy: "network-only",
    variables: {
      accountId: props.accountId
    }
  })
})

export default withQuery(AccountHolderPropertiesPanel);